// Language context for Turkish/English UI and meal text.
import React, { createContext, useContext, useEffect, useState } from 'react';

const LangContext = createContext(null);

const dict = {
  tr: {
    'home.greeting_with': 'Selâmün Aleyküm',
    'home.continue_from': 'Kaldığın yerden devam et',
    'home.new_journey': 'Yeni bir yolculuk başlat',
    'home.today_question': 'Bugün ne yapalım?',
    'home.stat.streak': 'Çalışma Serisi',
    'home.stat.minutes': 'Toplam Süre',
    'home.stat.memorized': 'Ezberlenen Ayet',
    'home.widget.hatim': 'Hatim İlerlemen',
    'home.widget.calendar': 'Dini Takvim',
    'home.widget.hadith': 'Günün Hadisi',
    'home.hatim.click': 'Hatime başlamak için tıkla',
    'home.calendar.click': 'Bugünün ibadetleri için tıkla',
    'quran.surah_list': 'Sure Listesi',
    'quran.read_arabic': 'Arapça Oku',
    'quran.read_meal': 'Meali Oku',
    'quran.ayah': 'Ayet',
    'quran.juz': 'Cüz',
    'quran.makki': 'Mekki',
    'quran.madani': 'Medeni',
    'common.continue': 'Devam Et',
    'common.start': 'Başla',
    'common.back': 'Geri',
    'common.loading': 'Yükleniyor...',
    'common.error': 'Bir hata oluştu',
    'common.coming_soon': 'Yakında',
    'common.completed': 'Tamamlandı',
    'common.units_cuz': 'cüz',
    'common.units_day': 'gün',
    'common.units_min': 'dk',
    'lang.tr': 'Türkçe',
    'lang.en': 'English',
    'lang.switcher': 'Dil',
  },
  en: {
    'home.greeting_with': 'Assalamu Alaikum',
    'home.continue_from': 'Continue where you left off',
    'home.new_journey': 'Begin a new journey',
    'home.today_question': 'What shall we do today?',
    'home.stat.streak': 'Practice Streak',
    'home.stat.minutes': 'Total Time',
    'home.stat.memorized': 'Memorized Verses',
    'home.widget.hatim': 'Hatim Progress',
    'home.widget.calendar': 'Religious Calendar',
    'home.widget.hadith': 'Hadith of the Day',
    'home.hatim.click': 'Tap to start Hatim',
    'home.calendar.click': 'Tap for today\'s worship',
    'quran.surah_list': 'Surah List',
    'quran.read_arabic': 'Read Arabic',
    'quran.read_meal': 'Read Translation',
    'quran.ayah': 'Ayah',
    'quran.juz': 'Juz',
    'quran.makki': 'Makki',
    'quran.madani': 'Madani',
    'common.continue': 'Continue',
    'common.start': 'Start',
    'common.back': 'Back',
    'common.loading': 'Loading...',
    'common.error': 'An error occurred',
    'common.coming_soon': 'Coming Soon',
    'common.completed': 'Completed',
    'common.units_cuz': 'juz',
    'common.units_day': 'days',
    'common.units_min': 'min',
    'lang.tr': 'Türkçe',
    'lang.en': 'English',
    'lang.switcher': 'Language',
  },
};

export const LangProvider = ({ children }) => {
  // Language is forced to Turkish — UI selector hidden.
  const [lang, setLang] = useState('tr');

  useEffect(() => {
    try { localStorage.setItem('hafizim_lang', 'tr'); } catch { /* ignore */ }
  }, []);

  const t = (key) => (dict[lang] && dict[lang][key]) || (dict.tr && dict.tr[key]) || key;
  const toggleLang = () => {}; // no-op while selector is disabled

  // Edition codes used by Quran content service
  const mealEdition = lang === 'en' ? 'en.sahih' : 'tr.diyanet';

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang, t, mealEdition }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used within LangProvider');
  return ctx;
};
